import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {
    // backgroundColor: '#e2dada',
  },
}));

export default styles;